import { render, staticRenderFns } from "./CharactersItem.vue?vue&type=template&id=76a40750&"
import script from "./CharactersItem.vue?vue&type=script&lang=js&"
export * from "./CharactersItem.vue?vue&type=script&lang=js&"
import style0 from "./CharactersItem.vue?vue&type=style&index=0&id=76a40750&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports